import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
import * as SwitchPrimitive from "@radix-ui/react-switch";
//#region src/switch/Switch.tsx
const Switch = ({ size = "md", ...restSwitchProps }) => {
	return /* @__PURE__ */ jsx(SwitchRoot, {
		size,
		...restSwitchProps,
		children: /* @__PURE__ */ jsx(SwitchThumb, { size })
	});
};
const SwitchRoot = ({ className, size = "md", children, ...rest }) => {
	return /* @__PURE__ */ jsx(SwitchPrimitive.Root, {
		className: twMerge(size === "sm" && "h-4 w-7", size === "md" && "h-5 w-9", size === "lg" && "h-7 w-12", "focus-visible:ring-ring focus-visible:ring-offset-background group relative shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden radix-disabled:cursor-not-allowed radix-disabled:opacity-50 radix-state-checked:bg-blue-500 radix-state-unchecked:bg-gray-300", className),
		...rest,
		children
	});
};
const SwitchThumb = ({ className, size = "md", ...rest }) => {
	return /* @__PURE__ */ jsx(SwitchPrimitive.Thumb, {
		className: twMerge(size === "sm" && "size-3 group-radix-state-checked:translate-x-3", size === "md" && "size-4 group-radix-state-checked:translate-x-4", size === "lg" && "size-6 group-radix-state-checked:translate-x-5", "absolute top-0 bottom-0 left-0 rounded-full bg-white shadow-lg ring-0 transition-transform", className),
		...rest
	});
};
const Root = SwitchRoot;
const Thumb = SwitchThumb;
//#endregion
export { Root, Switch, SwitchRoot, SwitchThumb, Thumb };
